module.exports = __webpack_public_path__ + "static/img/notice-dialog-btn-bg.eb8cb5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice-dialog-btn-bg.png
// module id = yhNt
// module chunks = 0